import { wasHeaderModalVisible } from '../actions/AppHeaderModalActions';
import i18n from '../../i18n';
import Pseudo from 'i18next-pseudo';

const LanguageState = (
  state = {
    isLanguageVisible: wasHeaderModalVisible('SHOW_LANGUAGES'),
    isPseudo: !localStorage.getItem('netacad-pseudo-localize')
      ? false
      : localStorage.getItem('netacad-pseudo-localize') === 'false'
      ? false
      : true
  },
  action
) => {
  switch (action.type) {
    case 'SHOW_LANGUAGES':
      return {
        ...state,
        isLanguageVisible: true
      };
    case 'HIDE_LANGUAGES':
      return {
        ...state,
        isLanguageVisible: false
      };
    case 'CLOSE_MODAL':
      return {
        ...state,
        isLanguageVisible: false
      };
    case 'PSEUDO_LOCALIZE_ON':
      localStorage.setItem('netacad-pseudo-localize', true);
      i18n
        .use(
          new Pseudo({
            enabled: true,
            languageToPseudo: localStorage.getItem('i18nextLng'),
            letterMultiplier: 4,
            repeatedLetters: ['B', 'o', 'a', 't']
          })
        )
        .init({ postProcess: ['pseudo'] });
      return {
        ...state,
        isPseudo: true
      };
    case 'PSEUDO_LOCALIZE_OFF':
      localStorage.setItem('netacad-pseudo-localize', false);
      i18n
        .use(
          new Pseudo({
            enabled: false,
            languageToPseudo: localStorage.getItem('i18nextLng'),
            letterMultiplier: 4,
            repeatedLetters: ['B', 'o', 'a', 't']
          })
        )
        .init({ postProcess: [] });
      return {
        ...state,
        isPseudo: false
      };
    default:
      return state;
  }
};
export default LanguageState;
